<div>
  <p id="header-text" style="text-align: start">
    Töltsd fel a szükséges fájlokat!
  </p>

  <div class="upload-row">
    <!-- Teljes videó feltöltő input -->
    <div id="video-upload-col" class="upload-row-col">
      <h3>Teljes videó</h3>
      <ngx-dropzone 
        [accept]="'.mp4'" 
        [multiple]="false"
        (change)="onVideoFileDropped($event)"
        class="video-dropzone">
        <ngx-dropzone-label>Húzd ide a videó fájlt (.mp4) vagy kattints a gombra</ngx-dropzone-label>
        <ngx-dropzone-preview *ngIf="videoFile" [removable]="true" (removed)="onVideoFileRemoved()">
          <ngx-dropzone-label>{{ videoFile.name }}</ngx-dropzone-label>
        </ngx-dropzone-preview>
      </ngx-dropzone>
      <br/>
      <input #videoInput type="file" (change)="onVideoInputChange($event)" accept=".mp4" style="margin-top: 10px;"/>
    </div>

    <!-- JSON metadata feltöltő input -->
    <div id="metadata-upload-col" class="upload-row-col">
      <h3>MrVegas JSON Metadata 📽</h3>
      <ngx-dropzone 
        [accept]="'.json'" 
        [multiple]="false"
        (change)="onMetadataFileDropped($event)"
        class="metadata-dropzone">
        <ngx-dropzone-label>Húzd ide a JSON metadata fájlt vagy kattints a gombra</ngx-dropzone-label>
        <ngx-dropzone-preview *ngIf="metadataFile" [removable]="true" (removed)="onMetadataFileRemoved()">
          <ngx-dropzone-label>{{ metadataFile.name }}</ngx-dropzone-label>
        </ngx-dropzone-preview>
      </ngx-dropzone>
      <br/>
      <input #metadataInput type="file" (change)="onMetadataInputChange($event)" accept=".json" style="margin-top: 10px;"/>
    </div>
  </div>

  <!-- Feltöltő gomb, ami a FullVideoUpload service-t hívja -->
  <button mat-raised-button color="primary" id="upload-button" (click)="onTapUpload()">
    Feltöltés
  </button>
</div>



